import React, { useState, ChangeEvent } from 'react';
import { Card, Form, Input, Button } from 'antd';
import { PlusOutlined, MinusOutlined, CloseOutlined } from '@ant-design/icons';

interface ArithmeticFunctionsProps {
    selectedFunction: string;
    onSave: (expression: string) => void;
}

const ArithmeticFunctions: React.FC<ArithmeticFunctionsProps> = ({ selectedFunction, onSave }) => {
    const [argumentsList, setArgumentsList] = useState<string[]>(['', '']);

    const handleAddArgument = () => {
        setArgumentsList([...argumentsList, '']);
    };

    const handleRemoveArgument = () => {
        if (argumentsList.length > 0) {
            setArgumentsList(argumentsList.slice(0, -1));
        }
    };

    const handleArgumentChange = (index: number, event: ChangeEvent<HTMLInputElement>) => {
        const newArgs = [...argumentsList];
        newArgs[index] = event.target.value;
        setArgumentsList(newArgs);
    };

    const handleSave = () => {
        const expression = `${selectedFunction}(${argumentsList.join(';')})`;
        onSave(expression);
    };

    const resolveFunctionName = (selectedFunction) => {
        switch (selectedFunction){
            case 'add':
                return 'Addieren';
            case 'subtract':
                return 'Subtrahieren';
            case 'multiply':
                return 'Multiplizieren';
            case 'divide':
                return 'Dividieren';
        }
    }

    const getOperatorIcon = (selectedFunction) => {
        switch (selectedFunction) {
            case 'add':
                return <PlusOutlined />;
            case 'subtract':
                return <MinusOutlined />;
            case 'multiply':
                return <CloseOutlined />;
            case 'divide':
                return <span style={{ fontSize: '14px'}}>÷</span>;
            default:
                return null;
        }
    };

    return (
        <Card title={`Funktion: ${resolveFunctionName(selectedFunction)}`} bordered={false}>
            <Form.Item label="Argumente">
                {argumentsList.map((arg, index) => (
                    <div key={index}>
                        <Input
                            value={arg}
                            onChange={(e) => handleArgumentChange(index, e)}
                            style={{ marginBottom: 8 }}
                        />
                        {index < argumentsList.length - 1 && (
                            <div style={{ textAlign: 'center', marginBottom: 8 }}>{getOperatorIcon(selectedFunction)}</div>
                        )}
                    </div>
                ))}
                <Button onClick={handleAddArgument}>Argument hinzufügen</Button>
                <Button onClick={handleRemoveArgument}>Argument entfernen</Button>
            </Form.Item>
            <Button type="primary" onClick={handleSave}>Speichern</Button>
        </Card>
    );
};

export default ArithmeticFunctions;
